import { registerLocaleData } from '@angular/common';
import { Component, inject, Input, signal } from '@angular/core';
import { IImage } from '@web-nx-ng-tsc/web-shared-data-access';
import { DomSanitizer } from '@angular/platform-browser';
import localeTh from '@angular/common/locales/th';

import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import 'dayjs/locale/th';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

dayjs.extend(buddhistEra).locale('th');

dayjs.extend(customParseFormat);

registerLocaleData(localeTh, 'th');

@Component({
  selector: 'lib-web-shared-ui-promotion-detail',
  standalone: true,
  imports: [],
  providers: [
    { provide: 'LOCALE_ID', useValue: 'th' }, // Set Thai as the default locale
  ],
  templateUrl: './lib-promotion-detail.component.html',
  styleUrl: './lib-promotion-detail.component.scss',
})
export class LibPromotionDetailComponent {
  @Input() set data(value: IImage) {
    value.publish_time = this.formatThaiDate(value.publish_time ?? '');
    value.unpublish_time = this.formatThaiDate(value.unpublish_time ?? '');
    this.dataSignal.set(value);
    this.loggingService.log('newvalue', this.dataSignal());
  }

  private readonly domSanitizer = inject(DomSanitizer);
  private readonly loggingService = inject(LoggingService);

  publicTimeFormat = signal<string>('');

  dataSignal = signal<IImage>({
    img: '',
    title: '',
    contentHTML: '',
    seoPageTitle: '',
    seoMetaDescription: '',
    seoUrl: '',
    publish_time: '',
    unpublish_time: '',
  });

  formatThaiDate(datePromo: string) {
    if (datePromo == '') {
      return '';
    }
    this.loggingService.log(datePromo);
    this.loggingService.log(dayjs(datePromo).format('DD MMM BBBB'));
    return dayjs(datePromo, 'DD/MM/YYYY').format('DD MMM BBBB');
  }

  getSafeHtml(htmlString: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(htmlString);
  }
  public readonly replaceBucket = new ReplaceBucket();
}
